import instructorActionTypes from "modules/instructor/duck/types"
import userActionTypes from "modules/users/duck/types"

export default {
  instructor: instructorActionTypes,
  users: userActionTypes,
}
